"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitializablePermittableFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var InitializablePermittableFactory = /** @class */ (function (_super) {
    __extends(InitializablePermittableFactory, _super);
    function InitializablePermittableFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    InitializablePermittableFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    InitializablePermittableFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    InitializablePermittableFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    InitializablePermittableFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    InitializablePermittableFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return InitializablePermittableFactory;
}(contracts_1.ContractFactory));
exports.InitializablePermittableFactory = InitializablePermittableFactory;
var _abi = [
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PERMIT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b50610249806100206000396000f3fe608060405234801561001057600080fd5b506004361061004c5760003560e01c806330adf81f146100515780633644e5151461008b57806354fd4d50146100945780637ecebe00146100a9575b600080fd5b6100787f6e71edae12b1b97f4d1f60370fef10105fa2faae0126114a169c64845d6126c981565b6040519081526020015b60405180910390f35b61007860025481565b61009c6100c9565b6040516100829190610185565b6100786100b7366004610157565b60036020526000908152604090205481565b600180546100d6906101d8565b80601f0160208091040260200160405190810160405280929190818152602001828054610102906101d8565b801561014f5780601f106101245761010080835404028352916020019161014f565b820191906000526020600020905b81548152906001019060200180831161013257829003601f168201915b505050505081565b600060208284031215610168578081fd5b81356001600160a01b038116811461017e578182fd5b9392505050565b6000602080835283518082850152825b818110156101b157858101830151858201604001528201610195565b818111156101c25783604083870101525b50601f01601f1916929092016040019392505050565b600181811c908216806101ec57607f821691505b6020821081141561020d57634e487b7160e01b600052602260045260246000fd5b5091905056fea26469706673582212201a6910cd54beb0433a2cb288d9dfd5b87f437282fe65f1fd0dcd960ad409581c64736f6c63430008040033";
